import { FavoriteBtn } from '@components/FavoriteBtn';
import { getDefalutImgUrl } from '@constants/config';
import { type GemItemType, getGemTypeString } from '@constants/gemType';
import { useSetSearchParams } from '@hook/useSetSearchParams';
import { type IDicItem } from '@interface/IItemDic';
import classNames from 'classnames';

export const DicItem = ({ it }: { it: IDicItem }) => {
    const options = it.options?.filter((op) => op !== '').join(', ');
    const optionsDesc = options || '-';
    const setParams = useSetSearchParams();

    return (
        <div className={classNames({ 'has-option': options }, 'tablerow')} data-id={it.id}>
            <div className="tablecell favorite">
                <FavoriteBtn itemId={it.id} isFav={it.favorite} type={'item'} ga360str="시세_리스트_즐겨찾기_클릭" />
            </div>
            <div className="tablecell">
                <button className="btn-item" onClick={() => setParams({ detail: `item_${it.id}_${it.level || 1}_0` })}>
                    <img className="thumb" src={it.image} onError={(e) => (e.currentTarget.src = getDefalutImgUrl())} />
                    <strong className="name" data-itemgrade={it.grade}>
                        {it.name} {getGemTypeString(it.category2 as GemItemType)}
                    </strong>
                    {!it.tradable && <span className="tradable" title="각인" />}
                </button>
            </div>
            <div className="tablecell">{it.categoryName || '-'}</div>
            <div className="tablecell">{optionsDesc}</div>
        </div>
    );
};
